/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { switchMap$ } from '@gh/rx/operators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BreakpointManager } from '../services';

@Directive({
  standalone: false,
  selector: '[ghIfBreakpoint]',
})
export class IfBreakpointDirective implements OnInit, OnDestroy {
  private breakpoint$$ = new BehaviorSubject<string>('');
  private rendered: boolean = false;
  private subscription: Subscription;

  @Input('ghIfBreakpoint')
  set breakpoint(breakpoint: string) {
    if (!breakpoint) {
      throw new Error('IfBreakpointDirective: breakpoint cannot be undefined');
    }
    this.breakpoint$$.next(breakpoint);
  }

  get breakpoint(): string {
    return this.breakpoint$$.value;
  }

  constructor(private breakpoints: BreakpointManager,
              private viewContainerRef: ViewContainerRef,
              private template: TemplateRef<any>) {
  }

  ngOnInit(): void {
    if (!this.breakpoint) {
      throw new Error('IfBreakpointDirective: breakpoint cannot be undefined');
    }
    this.subscription = this.breakpoint$$.pipe(
      switchMap$((breakpoint) => this.breakpoints.observeMatches(breakpoint)))
      .subscribe((matches) => this.setRendered(matches));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setRendered(shouldBeRendered: boolean): void {
    if (this.rendered === shouldBeRendered) {
      return;
    }

    if (this.rendered) {
      this.viewContainerRef.clear();
    }
    if (shouldBeRendered) {
      this.viewContainerRef.createEmbeddedView(this.template);
    }

    this.rendered = shouldBeRendered;
  }
}
